import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Helmet } from "react-helmet";
import { useOutletContext } from "react-router";
import { useAuth } from "hooks";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import { RelatedRoles, RoleDetails, RoleVetting } from "components/Missions/Roles";
import { MissionAboutClient } from "components/Missions";
import Card from "components/Card";

/**
 * Mission Role Vetting
 */
const MissionRoleVetting = () => {
  const intl = useIntl();
  const { canViewUnpublishedRoles } = useAuth();
  const { selectedRole, mission, loading } = useOutletContext();

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Role.Vetting.Title" })}</title>
      </Helmet>
      <PageWrapper>
        <Grid>
          <Grid.col start={1} end={13}>
            <PageTitle subtitle={<FormattedMessage id="Missions.Roles.Vetting.Title" />} />
          </Grid.col>
          <Grid.col start={1} end={9}>
            <RoleVetting role={selectedRole} loading={loading} />
          </Grid.col>
          <Grid.col start={9} end={13}>
            <Grid>
              <Grid.col start={1} end={13}>
                <Card>
                  <RoleDetails role={selectedRole} mission={mission} isLoading={loading} />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <RelatedRoles
                    missionId={mission?.uuid}
                    isLoading={loading}
                    canViewUnpublishedRoles={canViewUnpublishedRoles}
                  />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <MissionAboutClient mission={mission} isLoading={loading} />
                </Card>
              </Grid.col>
            </Grid>
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

export default MissionRoleVetting;
